/**
 * Branding Tab Component
 * Manages partner brand customization
 */
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { updatePartnerBranding } from '../../lib/api';

const BrandingTab = ({ partner }) => {
  return (
    <div className="space-y-6 mt-6">
      <Card>
        <CardHeader>
          <CardTitle className="font-heading">Brand Customization</CardTitle>
          <CardDescription>Customize the look and feel of your embedded widgets</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Primary Color</Label>
              <div className="flex gap-2">
                <Input
                  type="color"
                  value={partner.branding?.primary_color || '#047857'}
                  className="w-16 h-10 p-1"
                  onChange={(e) => updatePartnerBranding({ primary_color: e.target.value })}
                />
                <Input value={partner.branding?.primary_color || '#047857'} readOnly className="font-mono" />
              </div>
            </div>
            <div className="space-y-2">
              <Label>Secondary Color</Label>
              <div className="flex gap-2">
                <Input
                  type="color"
                  value={partner.branding?.secondary_color || '#065f46'}
                  className="w-16 h-10 p-1"
                  onChange={(e) => updatePartnerBranding({ secondary_color: e.target.value })}
                />
                <Input value={partner.branding?.secondary_color || '#065f46'} readOnly className="font-mono" />
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <Label>Logo URL</Label>
            <Input
              value={partner.branding?.logo_url || ''}
              placeholder="https://yourcompany.com/logo.png"
              className="rounded-xl"
              onChange={(e) => updatePartnerBranding({ logo_url: e.target.value })}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BrandingTab;
